export type UrlParams = { [key: string]: string };
export type Params = { [key: string]: any };

export const decodeParams = (params: UrlParams) => {
  const encodedParams: Params = {};

  for (const [key, value] of Object.entries(params)) {
    encodedParams[key] = JSON.parse(value);
  }

  return encodedParams;
};

export const encodeParams = (params: Params) => {
  const encodedParams: { [key: string]: string } = {};

  for (const [key, value] of Object.entries(params)) {
    encodedParams[key] = JSON.stringify(value);
  }

  return encodedParams;
};
export const getSearchParams = (searchParams: URLSearchParams) => {
  const params: { [key: string]: string } | null = {};
  let data = searchParams.entries();

  for (const value of data) {
    params[value[0]] = value[1];
  }

  return params;
};
